import { Pipe, PipeTransform } from '@angular/core';
import { IDataGenericText } from '@app/interfaces/idata-grouped';

@Pipe({
  name: 'genericText'
})
export class GenericTextPipe implements PipeTransform {


  transform(value: number, dataSelect: Array<IDataGenericText>) {

    if (!value)
      return '';

    const item = dataSelect.find(e => e.id === value);

    if (item)
      return item.text;

    return '';
  }
}
